import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateFarmDataSubmissionAdmin } from "services";

import { GET_FARM_DATA_SUBMISSION_STATUS, GET_FARM_REPORTING_YEAR, UPDATE_FARM_DATA_SUBMISSION_ADMIN } from "consts";

export const useUpdateFarmDataSubmissionAdmin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_FARM_DATA_SUBMISSION_ADMIN],
    mutationFn: updateFarmDataSubmissionAdmin,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DATA_SUBMISSION_STATUS] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_REPORTING_YEAR] });
    },
  });
};
